<template>
  <div>
    <pxkeji-rightHeader />

    <div class="pxkeji-right-box">
      <pxkeji-btn name="添加" class="pxkeji_basic_btn" @click="showInfo(0)" type="primary" v-btnlimit="'题目分类-添加'" />
      <a-table
        :columns="list.columns"
        rowKey="id"
        :dataSource="list.datas"
        :locale="{emptyText:'暂无数据'}"
        :loading="isloading"
        :pagination="list.pagination"
        @change="onChange"
        childrenColumnName="list"
      >
        <span slot="action" slot-scope="action">
          <pxkeji-btn name="编辑" size="small" @click="showInfo(action.id)" type="primary" v-btnlimit="'题目分类-编辑'" />
          <a-divider type="vertical" />
          <pxkeji-btn name="删除" size="small" @click="delInfo(action.id)" type="default" v-btnlimit="'题目分类-删除'" />
        </span>
      </a-table>
    </div>

    <a-modal
      :title="info.title"
      v-model="info.visible"
      width="50%"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <Info @callbackMethod="save" :id="info.id" />
    </a-modal>
  </div>
</template>
<script>
import Info from "./typeInfo.vue"; //编辑

var that;
var columns = [
  {
    dataIndex: "name",
    key: "name",
    align: "left",
    title: "名称"
  },
  {
    key: "action",
    align: "center",
    title: "操作",
    scopedSlots: { customRender: "action" }
  }
];
export default {
  name: "columnlist",
  data() {
    return {
      expand: false, //高级搜索
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      isloading: false,
      info: {
        title: "",
        visible: false,
        id: 0
      }
    };
  },
  components: {
    Info
  },
  mounted: function() {
    this.$nextTick(function() {
      that = this;
      this.GetList();
    });
  },
  watch: {
    selectRows: function() {
      //console.log("watch", val);
    }
  },
  methods: {
    GetList() {
      //获取列表
      this.isloading = true;
      this.$api.questioncategory
        .getTree()
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data;
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    //查看订单
    showInfo(id) {
      this.info.title = id ? "编辑" : "新增";
      this.info.visible = true;
      this.info.id = id;
    },
    //子组件传值
    save() {
      this.info.visible = false;
      this.GetList();
    },
    close() {
      this.$confirm({
        title: "提示",
        content: "您确定要禁用么",
        okText: "确认",
        cancelText: "取消"
      });
    },
    delInfo(id) {
      this.$confirm({
        title: "您确定要删除此项吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.questioncategory
            .deleteById(id)
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {
          //console.log("Cancel");
        }
      });
    }
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}

.cang_sta {
  text-align: center;
}

.cang_sta img {
  width: 35px;
}
</style>

